import React from 'react';
import {
    makeStyles,
    withStyles,
    Typography as MuiTypography,
    TypographyProps,
    Grid as MuiGrid,
    GridProps,
    Container as MuiContainer
} from '@material-ui/core';

const desktopBreakpoint = 'lg';

export const Typography = withStyles<string, undefined, TypographyProps & {component?: string}>(
    theme => ({
        h4: {
            fontWeight: theme.typography.fontWeightBold,
            lineHeight: theme.typography.pxToRem(25),
            letterSpacing: '-0.2px',
            marginBottom: theme.spacing(1)
        },
        body2: {
            '& p': {
                marginBottom: 0
            }
        }
    })
)(MuiTypography);

export const Navbar = withStyles(
    theme => ({
        container: {
            position: 'fixed',
            display: 'flex',
            width: '100%',
            margin: theme.spacing(3, 'auto'),
            [theme.breakpoints.up(desktopBreakpoint)]: {
                justifyContent: 'flex-end'
            }
        }
    }),
    {name: 'NewTermsNav'}
)(({children, classes, ...props}: React.PropsWithChildren<GridProps>) => {
    return (
        <MuiGrid item lg={8} xs={12} {...props}>
            <MuiContainer
                className={classes.container}
                maxWidth="lg"
                component={MuiGrid}
                item
                lg={8}
                xs={12}>
                {children}
            </MuiContainer>
        </MuiGrid>
    );
});

export const Content = withStyles(
    theme => ({
        container: {
            marginTop: theme.spacing(20)
        }
    }),
    {name: 'NewTermsContent'}
)(({children, classes, ...props}: React.PropsWithChildren<GridProps>) => {
    return (
        <MuiGrid item lg={8} xs={12} {...props}>
            <MuiContainer maxWidth="md" className={classes.container}>
                {children}
            </MuiContainer>
        </MuiGrid>
    );
});

export const Sidebar = withStyles(
    theme => ({
        container: {
            [theme.breakpoints.down(desktopBreakpoint)]: {
                marginBottom: theme.spacing(10)
            },
            [theme.breakpoints.up(desktopBreakpoint)]: {
                position: 'fixed',
                backgroundColor: theme.palette.background.paper,
                padding: theme.spacing(12, 12, 6),
                height: '100%',
                width: '100%'
            }
        }
    }),
    {name: 'NewTermsSidebar'}
)(({children, classes, ...props}: React.PropsWithChildren<GridProps>) => {
    return (
        <MuiGrid item lg={4} xs={12} {...props}>
            <MuiGrid item lg={4} xs={12} className={classes.container}>
                <MuiContainer maxWidth="md" style={{height: '100%'}}>
                    {children}
                </MuiContainer>
            </MuiGrid>
        </MuiGrid>
    );
});

const useStyles = makeStyles(theme => ({
    root: {
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 2)
        }
    },
    divider: {
        margin: theme.spacing(8, 0)
    },
    sidebarForm: {
        height: '100%'
    }
}));

export default useStyles;
